import React from 'react';
import css from './SpCalendarHeader.module.scss';
import CalendarType from './SpCalendarTypeSelect';
import CalendarController from './SpCalendarController';

interface Props {
  baseDate: string;
  isList: boolean;
  hasPrev: boolean;
  onClickCalendar: () => void;
  onClickList: () => void;
  onClickNext: () => void;
  onClickPrev: () => void;
}

export const SpCouponCalendarHeader = ({
  baseDate,
  isList,
  hasPrev,
  onClickCalendar,
  onClickList,
  onClickNext,
  onClickPrev,
}: Props) => {
  return (
    <div className={css.root}>
      <CalendarType
        isList={isList}
        onClickCalendar={onClickCalendar}
        onClickList={onClickList}
      />
      <CalendarController
        baseDate={baseDate}
        onClickNext={onClickNext}
        onClickPrev={onClickPrev}
        hasPrev={hasPrev}
      />
    </div>
  );
};
